
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://a010682ea2bc4fe0900752c4ce8eb4b5@sentry.haltu.net/40',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
